import { TDateAppFormat } from '@/domains/types';

const getDateByStartOfPart = (date: TDateAppFormat, part: 'week' | 'month' | 'day' | 'minute') => date.clone().startOf(part);

export default getDateByStartOfPart;
